// extracted by mini-css-extract-plugin
export default {"button":"styles-module__button--BgyeE","button__header":"styles-module__button__header--NlMof","button__footer":"styles-module__button__footer--a558i"};